<mb-progress-bar *ngIf="loading$ | async" color="primary"></mb-progress-bar>
